import { injectable } from 'inversify';
import {computed, observable} from 'mobx';
import { SubscriptionsApi } from '../api/SubscriptionsApi';
import { UserSubscription } from '../interfaces/models/UserSubscriptionModel';
import Logger from '../utils/Logger';

@injectable()
export class SubscriptionStore {

    @observable subscriptions: UserSubscription[];
    @observable hasActiveSubscriptions = false;

    constructor(
        private subscriptionsApi: SubscriptionsApi
    ) {}

    @computed
    get containsBoughtSubscriptions() {
        return this.subscriptions.filter(s => !s.is_expired && !s.is_trial).length > 0
    }

    async loadSubscriptions() {
        try {
            const response = await this.subscriptionsApi.getSubscriptions();
            this.subscriptions = response.data;
            this.hasActiveSubscriptions = this.subscriptions.filter(s => !s.is_expired).length > 0;
        } catch (e) {
            Logger.error(e);
        }
    }

    async subscribeInApp(platform, productId, transactionReceipt) {
        try {
            return this.subscriptionsApi.subscribeInApp(platform, productId, transactionReceipt);
        } catch (e) {
            // Alert.alert('error', JSON.stringify(e));
            Logger.error(e);
        }
    }

}
